import React from 'react';

import { InternalFormProps } from './types';

const style = {
  display: 'block',
  width: '100%',
};

const Form: React.FC<InternalFormProps> = props => (
  <form
    id={props.id}
    style={style}
    onSubmit={props.onSubmit}
    noValidate={props.noValidate || true}
  >
    {props.children}
  </form>
);

export default Form;
